import { env } from 'constants';
import { CartContext } from 'constants/contexts';
import { useContext } from 'react';

function useMerchantPath(m) {
  const cart = useContext(CartContext);
  const merchant = m || cart.merchant;
  if (!merchant) return null;
  if (env.IS_CATERING && !env.IS_MARKETPLACE) {
    return '/';
  }
  return `/place/${merchant.id}/${merchant.slug || ''}`;
}

export default useMerchantPath;
